import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 13a.997.997 0 0 1-.707-.293L10 8.414l-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5A.999.999 0 0 1 15 13",
  fillRule: "evenodd"
});

var SvgChevronUpMinor = function SvgChevronUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgChevronUpMinor as S };
